import { useMutation } from '@apollo/client';
import { Spinner } from '@radix-ui/themes';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { CONNECT_TO_LEVER } from '../../../../behavior/queries/integration';

const Integrations = () => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [leverError, setLeverError] = useState('');
  const [integrateLever] = useMutation(CONNECT_TO_LEVER);

  const integration = async (code: string, clientId: string) => {
    setLoading(true);
    try {
      const response = await integrateLever({
        variables: {
          code: code,
          clientId: clientId,
        },
      });
      if (response.data.integrateLever.__typename !== 'LeverIntegrationSuccess') {
        if (window.opener !== null) {
          window.opener.onError(response.data.integrateLever.message);
          setLoading(false);
          window.close();
        }
        setLoading(false);
        setLeverError(response.data.integrateLever.message);
      }
      if (response.data.integrateLever.success === 'OK') {
        if (window.opener !== null) {
          window.opener.onSuccess(true);
          setLoading(false);
          window.close();
        }
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      setLeverError((error as { data: { message: string } }).data.message);
    }
  };

  useEffect(() => {
    setLoading(true);
    if (new URLSearchParams(search).get('error') !== null) {
      const errorDescription = new URLSearchParams(search).get('error_description') ?? '';
      setLeverError(errorDescription);
      setLoading(false);
    } else {
      const code = new URLSearchParams(search).get('code') ?? '';
      if (window.opener !== null) {
        const clientId = window.opener.onOpen();
        integration(code, clientId);
      }
    }
  }, []);

  return (
    <div className="main-container mx-auto">
      {loading && (
        <div className="centerSpinner">
          <Spinner size="3" role="status" aria-hidden="true" />
        </div>
      )}
      {!loading && (
        <div className="border rounded p-4">
          <h2 className="truncate pb-4">{leverError}</h2>
        </div>
      )}
    </div>
  );
};

export default Integrations;
